import { render, staticRenderFns } from "./PreferencesSettings.vue?vue&type=template&id=af2404ce"
import script from "./PreferencesSettings.vue?vue&type=script&lang=js"
export * from "./PreferencesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports